import featureFlags from '../../FeatureFlags';

const isVerifactuFeatureFlagAddBusinessActive = () => {
  const flag = 'allowVerifactuAddBusiness';
  return featureFlags.getFlag(flag) as boolean;
};

export default isVerifactuFeatureFlagAddBusinessActive;
